import React from 'react';
import dva, { dynamic, router } from 'dva';
import createLoading from 'dva-loading';
import { createBrowserHistory } from 'history';
import request from 'cmn-utils/lib/request';
import createRoutes from '@/routes';
import 'assets/styles/index.less';
import config from './config';
import { ConfigProvider } from 'antd';
import zh_CN from 'antd/es/locale/zh_CN';
import { homepage } from '../package.json';
import * as serviceWorker from './serviceWorker';
import './utils/prototypeChange';
import './global.less'

import moment from 'moment';
import 'moment/locale/zh-cn'
moment.locale('zh-cn'); 

const { Router } = router;

// -> 初始化
const app = dva({
  history: createBrowserHistory({
    basename: homepage.startsWith('/') ? homepage : ''
  })
});

// -> 插件
app.use(createLoading());
app.use({ onError: config.exception.global });

// -> 请求
request.config(config.request);


// -> loading
dynamic.setDefaultLoadingComponent(() => config.router.loading);

// -> 注册全局模型
app.model(require('./models/global').default);

// -> 初始化路由
app.router(({ history, app }) => (
  <ConfigProvider locale={zh_CN}>
    <Router history={history}>{createRoutes(app)}</Router>
  </ConfigProvider>
));

// -> Start
app.start('#root');

// export global
export default {
  app,
  store: app._store,
  dispatch: app._store.dispatch
};


serviceWorker.unregister();